import { useContext, useEffect, useState } from 'react';
import useMobile from 'hooks/useMobile';
import DepartmentContext from '../../../contexts/departments/context';
import MenuChatsContext from '../../../contexts/menuChats/context';
import useEnvironment from '../../../hooks/useEnvironments';
import useSegment from '../../../services/Analytics';

const useQueueMenu = () => {
  const { departments } = useContext(DepartmentContext);
  const [tabTitle, setTabTitle] = useState<string>('allChats');
  const [showModalChangeStatus, setShowModalChangeStatus] = useState(false);
  const [showModalLogout, setShowModalLogout] = useState(false);
  const [showEditProfileModal, setShowEditProfileModal] = useState(false);
  const { departmentsSelected } = useContext(MenuChatsContext);
  const { isMobileView } = useMobile();
  const [showModalIsMobile, setShowModalIsMobile] = useState(false);

  const [tabValue, setTabValue] = useState(0);
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);

  const [openPreferences, setOpenPreferences] = useState(false);
  const [anchorElAvatar, setAnchorElAvatar] = useState<HTMLDivElement | null>(null);

  const [statusOptions, setStatusOptions] = useState<Array<any>>([]);
  const [domain, setDomain] = useState('');
  const { getBasePath } = useEnvironment();
  const { sendMenuHomeEvent } = useSegment();
  const [avatarUrl, setAvatarUrl] = useState('');

  const handleTabTitle = () => {
    if (departmentsSelected && (!departmentsSelected.length || departmentsSelected.length === departments.length)) {
      setTabTitle('allChats');
    } else {
      const title = departments
        .filter((item) => departmentsSelected.includes(item._id))
        .map((item) => item.name)
        .join(',');
      setTabTitle(title);
    }
  };

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    sendMenuHomeEvent(newValue);
  };

  const handleOptionClick = (event: HTMLDivElement) => {
    setAnchorEl(event);
  };

  const handleClickAvatar = (event: React.MouseEvent<HTMLDivElement>) => {
    setAnchorElAvatar(event.currentTarget);
  };

  const handleClickPreferences = () => {
    setOpenPreferences((state) => !state);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setAnchorElAvatar(null);
  };

  const handleOpenAdminPanel = () => {
    if (isMobileView) {
      setShowModalIsMobile(true);
      return;
    }
    window.open(`${domain}/service-manager`)?.focus();
  };

  useEffect(() => {
    const path = getBasePath();
    setDomain(path);
  }, []);

  useEffect(() => {
    handleTabTitle();
  }, [departmentsSelected]);

  return {
    departments,
    tabTitle,
    showModalChangeStatus,
    showModalLogout,
    showEditProfileModal,
    setShowModalChangeStatus,
    setShowModalLogout,
    setShowEditProfileModal,
    handleChange,
    handleOptionClick,
    handleClickAvatar,
    handleClose,
    tabValue,
    anchorEl,
    anchorElAvatar,
    statusOptions,
    domain,
    setStatusOptions,
    handleClickPreferences,
    openPreferences,
    handleOpenAdminPanel,
    isMobile: isMobileView,
    showModalIsMobile,
    setShowModalIsMobile,
    avatarUrl,
    setAvatarUrl,
  };
};

export default useQueueMenu;
